import "./Stories.scss"
import { sectionTitle, storiesData } from "../Header_Utils/header_utils"

// generate a story card
const StoriesCard = ({ name, location, quote, achievement, achievementCount, avatar }) => {
  return (
    <div className="story-card">
      <div>
        <div>{avatar}</div>
        <div>
          <h3>{name}</h3>
          <p><i className="ri-map-pin-line"></i> {location}</p>
        </div>
      </div>

      <p>{quote}</p>

      <div>
        <i className="ri-trophy-line mr-2"></i>
        <span>
          {achievementCount} {achievement}
        </span>
      </div>
    </div>
  )
}


 const StoriesSection = () => {
  return (
    <section className="stories">
      <div>
        {/* a util func to gen a title  */}
        {sectionTitle("Stories of Transformation", `Real stories from young farmers whose lives have been transformed through our programs and community
            support.`)}
        <div>
            {/* map over the stories data  */}
          {storiesData.map((story) => (
            <StoriesCard
            avatar={story.avatar}
              key={story.id}
              name={story.name}
              location={story.location}
              quote={story.quote}
              achievement={story.achievement}
              achievementCount={story.achievementCount}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default StoriesSection